import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=0752e0bd&scoped=true&"
import script from "./TaskView.vue?vue&type=script&lang=js&"
export * from "./TaskView.vue?vue&type=script&lang=js&"
import style0 from "./TaskView.vue?vue&type=style&index=0&id=0752e0bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0752e0bd",
  null
  
)

export default component.exports